import { TriangleAlert } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ErrorIcon = DeckardIconWrapper({ Icon: TriangleAlert });
